import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { send } from "../../SendRequest";
import { getFormTitleParam, isObjectNotEmpty } from "../../Utils";
import AlertDialog from "../../component/AlertDialog/AlertDialog";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getFormTitleParamList } from "../../redux/selector";

const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    container: {
        maxHeight: 250,
    },
    tableRow: {
        height: 15,
    },
    tableCell: {
        height: 10,
    },
    reminderBox: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 100px 0px 20px",
    },
    reminderBoxMobile: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 20px 0px 20px",
    },
});

function EditReviewerEdb() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();

    const [domainName, setDomainName] = useState("");

    const [reviewerList, setReviewerList] = useState([]);

    const [isSavedOpen, setIsSavedOpen] = useState(false);
    const handleSavedClose = () => {
        setIsSavedOpen(false);
    };

    const [refresh, setRefresh] = useState(false);
    const [isCurrReviewer, setIsCurrReviewer] = useState(false);
    const [infoInUse, setInfoInUse] = useState(false);
    const [isPostNoContainUser, setIsPostNoContainUser] = useState(false);
    const [removeRelatedSetting, setRemoveRelatedSetting] = useState(false);

    const [apiError, setApiError] = useState(false);

    const [apiErrorMsg, setApiErrorMsg] = useState("");

    // const cloTwoForms = [21, 31]; //form22 no reviewer for clo2
    const [isCloTwo, setIsCloTwo] = useState("R");
    // const workflowNumList = new Array(99).fill(["R"]);
    // cloTwoForms.forEach((i) => (workflowNumList[i - 1] = ["R", "R2"]));
    const handleConfirm = () => {
        setIsCurrReviewer(false);
        setInfoInUse(false);
        setIsPostNoContainUser(false);
        setRemoveRelatedSetting(false);
    };

    const formTitleParam = useSelector(getFormTitleParamList());

    function SavedDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.savedSuccessfully")}
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("common.portal.changesSaved")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    function addStaff(domainName) {
        const newReviewer = {
            post: domainName,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/users/addReviewers/${selectedForm}/${isCloTwo}`,
            method: "POST",
            body: JSON.stringify(newReviewer),
        };
        if (
            reviewerList?.every(
                (item) =>
                    domainName?.toLowerCase() !=
                    item.post?.trim()?.toLowerCase()
            )
        ) {
            dispatch(send("ADD_REVIEWER", option))
                .then((response) => response.json())
                .then((result) => {
                    if (result?.success) {
                        setReviewerList(result?.data);
                    } else if (result?.code === "2001") {
                        setIsCurrReviewer(true);
                    } else if (result?.code === "2002") {
                        setInfoInUse(true);
                    } else if (result?.code === "2007") {
                        setIsPostNoContainUser(true);
                    } else {
                        setApiError(true);
                        setApiErrorMsg(result?.message);
                    }
                    setDomainName("");
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                    setInfoInUse(true);
                });
        } else {
            setIsCurrReviewer(true);
        }
    }

    function deleteReviewer(item) {
        const option = {
            url: `${Config.CONTENT_PATH}/users/removeReviewers/${selectedForm}/${isCloTwo}`,
            method: "PUT",
            body: JSON.stringify(item),
        };
        dispatch(send("REMOVE_REVIEWER", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success) {
                    setReviewerList(result?.data);
                } else if (result?.code === "2008") {
                    setRemoveRelatedSetting(true);
                } else {
                    setApiError(true);
                    setApiErrorMsg(result?.message);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }

    // const onSubmit = () => {
    //     setIsSavedOpen(true);
    //     console.log("submitted:" + JSON.stringify(reviewerList));
    // };

    const [formList, setFormList] = useState([]);
    const [selectedForm, setSelectedForm] = useState(0);
    // const [districts, setDistricts] = useState([]);
    // const [finalReviewers, setFinalReviewers] = useState({});

    useEffect(() => {
        try {
            const fetchFormList = async () => {
                const option = {
                    url: `${Config.CONTENT_PATH}/users/getReviewerDropdown`,
                };
                const res = await dispatch(
                    send("GET_REVIEWER_DROPDOWN", option)
                );
                try {
                    const data = await res.json();
                    if (data.success === true && data.code === "0") {
                        const result = data?.data || {};
                        setSelectedForm(result.userFormList[0]);
                        setFormList(result.userFormList);
                    }
                } catch (error) {
                    console.error(error);
                }
            };
            // const fetchDistricts = async () => {
            //     const option = {
            //         url: `${Config.CONTENT_PATH}/reo/getDistrict`,
            //     };
            //     const res = await dispatch(send("GET_DISTRICTS", option));
            //     try {
            //         const data = await res.json();
            //         setDistricts(data);
            //     } catch (error) {
            //         console.error(error);
            //     }
            // };
            fetchFormList();
            // fetchDistricts();
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        getReviewersForm();
    }, [selectedForm]);

    useEffect(() => {
        getReviewersCloForm();
    }, [isCloTwo]);

    const getReviewersForm = () => {
        setRefresh(true);
        setIsCloTwo("R");
        if (selectedForm == 0 || !isObjectNotEmpty(selectedForm)) {
            return;
        }
        const option = {
            url: `${Config.CONTENT_PATH}/users/reviewers/${selectedForm}`,
        };
        dispatch(send("GET_REVIEWER", option))
            .then((response) => response.json())
            .then((result) => {
                if (result.success === true && result.code === "0") {
                    setReviewerList(result?.data || []);
                }
                // setFinalReviewers(result);
                setDomainName("");
                setRefresh(false);
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    };
    const getReviewersCloForm = () => {
        if (selectedForm == 0) {
            return;
        }
        if (!refresh) {
            const option = {
                url: `${Config.CONTENT_PATH}/users/reviewers/${selectedForm}/${isCloTwo}`,
            };
            dispatch(send("GET_REVIEWER", option))
                .then((response) => response.json())
                .then((result) => {
                    console.log("result: ", result);
                    setReviewerList(result);
                    // setFinalReviewers(result);
                    setDomainName("");
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                });
        }
    };

    // function changeDistrict(newList, formUserId) {
    //     let result = newList.map((x) => x.id);
    //     setFinalReviewers(
    //         finalReviewers.map((item) => {
    //             if (item.formUserId === formUserId) {
    //                 return { ...item, districtId: result };
    //             } else {
    //                 return item;
    //             }
    //         })
    //     );
    // }

    // function updateUserDistrict(latestReviewers) {
    //     const option = {
    //         url: `${Config.CONTENT_PATH}/reo/updateDistrict/${selectedForm}/${isCloTwo}`,
    //         method: "POST",
    //         body: JSON.stringify(latestReviewers),
    //     };
    //     dispatch(send("UPDATE_DISTRICTS", option))
    //         .then((response) => response.json())
    //         .then((result) => {
    //             setFinalReviewers(result);
    //         })
    //         .catch((error) => {
    //             console.log("fetch error: ", error);
    //         });
    // }

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.editReviewerEdb")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                {formList.length > 0 && selectedForm != 0 && (
                    <main Box className="main">
                        <Box sx={{ pl: "15px" }}>
                            <Box>
                                <Typography component="span">
                                    {t("common.portal.forForm")}&nbsp;
                                </Typography>
                                <FormControl id="formsId">
                                    <Select
                                        label="formsId"
                                        inputProps={{
                                            "aria-labelledby": "formsId",
                                        }}
                                        defaultValue={selectedForm}
                                        style={{ textAlign: "end" }}
                                        onChange={(e) =>
                                            setSelectedForm(e.target.value)
                                        }
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        {formList.map((element) => (
                                            <MenuItem
                                                value={element}
                                                key={element}
                                            >
                                                {element}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <Typography component="span">
                                    {t("common.colon")}
                                </Typography>
                                <Typography>
                                    {t(
                                        `form.Form${selectedForm
                                            .toString()
                                            .padStart(3, "0")}`,
                                        getFormTitleParam(
                                            selectedForm,
                                            formTitleParam,
                                            i18n.language
                                        )
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="h6" component="h1">
                                    <br />
                                    {t("common.portal.editCurrentReviewers")}
                                </Typography>

                                {/* <Box>
                                <Typography component="span">
                                    {t("common.portal.workflowType")}
                                </Typography>
                                <Select
                                    key={refresh}
                                    label="workflowNum"
                                    defaultValue={isCloTwo}
                                    style={{ textAlign: "end" }}
                                    onChange={(e) =>
                                        setIsCloTwo(e.target.value)
                                    }
                                >
                                    {workflowNumList[selectedForm - 1].map(
                                        (element) => (
                                            <MenuItem
                                                value={element}
                                                key={element}
                                            >
                                                {element === "R2"
                                                    ? "CLO 2"
                                                    : "CLO 1"}
                                            </MenuItem>
                                        )
                                    )}
                                </Select>
                            </Box> */}
                                <TableContainer
                                    component={Paper}
                                    style={{ maxHeight: "250px" }}
                                >
                                    <Table
                                        stickyHeader
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                {/* <TableCell
                                                    align="center"
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {t("common.portal.name")}
                                                </TableCell> */}
                                                {/* <TableCell
                                                    align="center"
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {t(
                                                        "common.portal.interfaceUsername"
                                                    )}
                                                </TableCell> */}
                                                {/* <TableCell
                                                    align="center"
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {t("common.portal.email")}
                                                </TableCell> */}
                                                <TableCell
                                                    align="center"
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {t("common.portal.post")}
                                                </TableCell>
                                                <TableCell component="td"></TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {isObjectNotEmpty(reviewerList)
                                                ? reviewerList?.map((item) => (
                                                      <React.Fragment
                                                          key={item.email}
                                                      >
                                                          <TableRow>
                                                              {/* <TableCell align="center">
                                                                  {item.name}
                                                              </TableCell> */}
                                                              {/* <TableCell align="center">
                                                                  {
                                                                      item.interfaceUsername
                                                                  }
                                                              </TableCell> */}
                                                              {/* <TableCell align="center">
                                                                  <a
                                                                      href={`mailto:${item.email}`}
                                                                      style={{
                                                                          color: "black",
                                                                      }}
                                                                  >
                                                                      {
                                                                          item.email
                                                                      }
                                                                  </a>
                                                              </TableCell> */}
                                                              <TableCell align="center">
                                                                  {item.post}
                                                              </TableCell>
                                                              <TableCell
                                                                  style={{
                                                                      width: "10px",
                                                                  }}
                                                              >
                                                                  <IconButton
                                                                      disabled={
                                                                          reviewerList?.length <=
                                                                          1
                                                                      }
                                                                      onClick={() =>
                                                                          deleteReviewer(
                                                                              item
                                                                          )
                                                                      }
                                                                      color="primary"
                                                                      aria-label="del"
                                                                  >
                                                                      <RemoveCircleIcon />
                                                                  </IconButton>
                                                              </TableCell>
                                                          </TableRow>
                                                      </React.Fragment>
                                                  ))
                                                : null}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Paper>
                                    <br />
                                    <CustomTextField
                                        label={
                                            <>
                                                <Typography component="span">
                                                    {t(
                                                        "common.portal.typeDomainNameReviewerStart"
                                                    )}
                                                </Typography>
                                                <AddCircleIcon
                                                    style={{
                                                        margin: "0 5px",
                                                        color: "#A74128",
                                                    }}
                                                />
                                                <Typography component="span">
                                                    {t(
                                                        "common.portal.typeDomainNameReviewerEnd"
                                                    )}
                                                </Typography>
                                            </>
                                        }
                                        id="typeDomainNameReviewer"
                                        placeholder={t(
                                            "common.portal.pleaseInputDomainNameReviewer"
                                        )}
                                        value={domainName}
                                        onChange={(e) =>
                                            setDomainName(e.target.value)
                                        }
                                        style={{
                                            width: matches ? "90%" : "85%",
                                        }}
                                        displayColon={false}
                                    ></CustomTextField>
                                    <IconButton
                                        onClick={() => {
                                            if (domainName != "")
                                                addStaff(
                                                    domainName?.replace(
                                                        /^\s+|\s+$/g,
                                                        ""
                                                    )
                                                );
                                        }}
                                        style={{ marginTop: "0.8rem" }}
                                        color="primary"
                                        aria-label="add"
                                    >
                                        <AddCircleIcon />
                                    </IconButton>
                                </Paper>
                            </Box>
                            <br />
                            {/* <Box>
                            <Typography variant="h6">
                                <br />
                                {t("common.portal.districtManagement")}
                            </Typography>
                            <TableContainer
                                component={Paper}
                                style={{ maxHeight: "250px" }}
                            >
                                <Table
                                    stickyHeader
                                    size="small"
                                    aria-label="district list"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                }}
                                                width="20%"
                                            >
                                                {t("common.portal.name")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                }}
                                                width="20%"
                                            >
                                                {t("common.portal.email")}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    fontWeight: "bold",
                                                }}
                                                width="60%"
                                            >
                                                {t("common.portal.district")}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {isObjectNotEmpty(finalReviewers) &&
                                        isObjectNotEmpty(districts)
                                            ? finalReviewers.map((item) => (
                                                  <React.Fragment
                                                      key={item.email}
                                                  >
                                                      <TableRow>
                                                          <TableCell
                                                              align="center"
                                                              width="20%"
                                                          >
                                                              {item.name}
                                                          </TableCell>
                                                          <TableCell
                                                              align="center"
                                                              width="20%"
                                                          >
                                                              <a
                                                                  href={`mailto:${item.email}`}
                                                                  style={{
                                                                      color: "black",
                                                                  }}
                                                              >
                                                                  {item.email}
                                                              </a>
                                                          </TableCell>
                                                          <TableCell
                                                              align="center"
                                                              width="60%"
                                                          >
                                                              <Autocomplete
                                                                  key={item.id}
                                                                  value={districts.filter(
                                                                      (x) =>
                                                                          item.districtId.includes(
                                                                              x.id
                                                                          )
                                                                  )}
                                                                  onChange={(
                                                                      e,
                                                                      newValue
                                                                  ) => {
                                                                      changeDistrict(
                                                                          newValue,
                                                                          item.formUserId
                                                                      );
                                                                  }}
                                                                  multiple={
                                                                      true
                                                                  }
                                                                  options={
                                                                      districts
                                                                  }
                                                                  getOptionLabel={(
                                                                      option
                                                                  ) =>
                                                                      option.district
                                                                  }
                                                                  renderInput={(
                                                                      params
                                                                  ) => (
                                                                      <TextField
                                                                          {...params}
                                                                          variant="standard"
                                                                          placeholder={t(
                                                                              "common.portal.districtInCharge"
                                                                          )}
                                                                      />
                                                                  )}
                                                              />
                                                          </TableCell>
                                                      </TableRow>
                                                  </React.Fragment>
                                              ))
                                            : null}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <FormBox>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                            updateUserDistrict(finalReviewers)
                                        }
                                    >
                                        {t("common.portal.saveBlock")}
                                    </Button>
                                </Box>
                            </FormBox>
                        </Box> */}
                            <br />
                            <br />
                        </Box>
                    </main>
                )}
            </Box>
            {isSavedOpen ? SavedDialog(isSavedOpen) : null}
            <AlertDialog
                formOpen={infoInUse}
                content={
                    <React.Fragment>
                        <Typography>
                            {t("common.portal.noDomainNameUser")}
                        </Typography>
                        <Typography>{t("common.portal.checkAgain")}</Typography>
                    </React.Fragment>
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={isCurrReviewer}
                content={
                    <Typography>
                        {t("common.portal.alreadyIncludedReviewer")}
                    </Typography>
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={isPostNoContainUser}
                content={
                    <Typography>
                        {t("common.portal.postNoContainUser")}
                    </Typography>
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={removeRelatedSetting}
                content={
                    <Typography>
                        {t("common.portal.removeRelatedSetting")}
                    </Typography>
                }
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
            <AlertDialog
                formOpen={apiError}
                content={<Typography>{apiErrorMsg}</Typography>}
                confirmButton={{
                    action: () => {
                        setApiError(false);
                        setApiErrorMsg("");
                    },
                    label: t("common.reload.popup.confirm"),
                }}
            />
        </Container>
    );
}
export default EditReviewerEdb;
